import {tsvParse} from "d3-dsv";
import dsv from "./dsv";

export default dsv("text/tab-separated-values", tsvParse);



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-request/src/tsv.js
// module id = 459
// module chunks = 0